import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

type Props = {
    icon?: React.ComponentType<any>;
    children: React.ReactNode;
};

export function ControlWithIcon(props: Props) {
    const Icon = props.icon;

    return (
        <>
            {Icon ? (
                <StackLegacy spacing={8} isHorizontal={true}>
                    <div
                        style={{
                            marginTop: 2,
                            marginLeft: 8,
                        }}
                    >
                        <Icon color={colors.grey} size={13} wrapWithDiv={false} />
                    </div>
                    <Divider variant='line--vertical' />
                </StackLegacy>
            ) : undefined}
            {props.children}
        </>
    );
}
